<template>

    <div class="zona_propuesta px-3">

      <div v-for="(oferta, index) in ofertasFiltradas" :key="index" :class="['caja_menu pb-4',{'pt-5': index > 0}]"
        :style="{ borderColor: participante.color_jornada }">
        <div v-if="oferta.titulo" class="ofe_titulo" :style="{ color: participante.color_jornada }">
          {{ oferta.titulo }}
        </div>
        <div v-if="oferta.texto" class="ofe_oferta_txt" v-html="oferta.texto" :style="{ color: participante.color_jornada }"></div>
        <div v-if="oferta.precio !='' " class="ofe_precio" :style="{ color: participante.color_jornada }">
          {{ $t("precio") }}: {{ oferta.precio }}
        </div>
        <div class="zona_pie" v-if="oferta.pie">
          <div class="ofe_pie" :style="{ color: participante.color_jornada }">
            {{ oferta.pie }}
          </div>
          <div v-if="oferta.subpie" class="ofe_subpie" :style="{ color: participante.color_jornada }">
            {{ oferta.subpie }}
          </div>
        </div>
      </div>
      
    </div>
     
</template>

<script setup>

import { computed } from "vue";


/* eslint-disable */
const props = defineProps({
  participante: {
    type: Object,
  },
});


// Crear el array de ofertas basado en los campos separados
const ofertas = computed(() =>
  [1, 2, 3].map((index) => ({
    titulo: props.participante[`ofe_titulo_${index}`] || null,
    texto: props.participante[`ofe_oferta_txt_${index}`] || null,
    precio: props.participante[`ofe_precio_${index}`] || '',
    pie: props.participante[`ofe_pie_${index}`] || null,
    subpie: props.participante[`ofe_subpie_${index}`] || null,
  }))
);

 // Filtrar ofertas válidas
 const ofertasFiltradas = computed(() =>
      ofertas.value.filter((oferta) => oferta.titulo || oferta.precio > 0)
    );




</script>
<style lang="scss" scoped>
/** añadidas */

.caja_menu {
  border-bottom: 2px dotted;
}

.caja_menu:last-child {
  border-bottom: none;
}

/**********/
</style>
